<template>
<div class="d-flex flex-column flex-lg-row justify-content-lg-center">
  <div class="invitation invitation__blue order-2 order-lg-1">
    <div class="invitation__intro">Wybierz wysokość jednorazowego wsparcia:</div>
    <AmountSelectOneTime @minus="minusOne" @plus="plusOne" :value="appData.formAmountOneValue" />
    <div class="btnO invitation__cta" :class="{disabled: appData.formAmountOneValue<25}" id="invitation__cta" @click="openOneTimeModal">Wspieram</div>
    <div class="invitation__box--blue">
      <div class="invitation__subtitle">{{ content.data.invitation.intro }}</div>
      <div
        v-for="item in oneTimePaymentBonus"
        :key="item"
        class="invitation__item"
      >
        <div class="invitation__check">

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.3 19">
            <g id="Warstwa_2" data-name="Warstwa 2">
              <g id="Warstwa_1-2" data-name="Warstwa 1">
                <path
                  d="M8.7,14,2.8,8.1a.6.6,0,0,0-.8,0L.2,9.9c-.3.3-.3.6,0,.8L6,16.6l2.2,2.2a.7.7,0,0,0,.9,0l2.2-2.2L25.1,2.8a.6.6,0,0,0,0-.8L23.3.2a.5.5,0,0,0-.8,0Z"
                  fill="#21397D"
                />
              </g>
            </g>
          </svg>
        </div>
        <div class="invitation__info" v-html="item">
        </div>
      </div>
    </div>
  </div>
   <div class="invitation order-1 order-lg-2 scale-lg">
    <div class="invitation__intro">{{ content.data.invitation.header }}</div>
    <AmountSelect @minus="minus" @plus="plus" :value="appData.formAmountSubValue" />
    <div class="btnS invitation__cta" :class="{disabled: appData.formAmountSubValue<25}" id="invitation__cta" @click="openSubscriptionModal">Wspieram</div>
    <div class="invitation__box">
      <div class="invitation__subtitle">{{ content.data.invitation.intro }}</div>

      <div
        v-for="item in content.data.invitation.content"
        :key="item"
        class="invitation__item"
      >
        <div class="invitation__check">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.3 19">
            <g id="Warstwa_2" data-name="Warstwa 2">
              <g id="Warstwa_1-2" data-name="Warstwa 1">
                <path
                  d="M8.7,14,2.8,8.1a.6.6,0,0,0-.8,0L.2,9.9c-.3.3-.3.6,0,.8L6,16.6l2.2,2.2a.7.7,0,0,0,.9,0l2.2-2.2L25.1,2.8a.6.6,0,0,0,0-.8L23.3.2a.5.5,0,0,0-.8,0Z"
                  fill="#ff6436"
                />
              </g>
            </g>
          </svg>
        </div>
        <div class="invitation__info" v-html="item">
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import AmountSelect from "./AmountSelect.vue";
import AmountSelectOneTime from "./AmountSelectOneTime.vue";
export default {
  inject: ["content", "appData"],
  data() {
    return {
      oneTimePaymentBonus: ['Dostajesz Rewolucyjną książkę kucharską!', "Współtworzysz z nami lepszą Polskę!"]
    }
  },
  methods: {
    minus() {
      this.$root.$emit("formAmountSubDown");
    },
    plus() {
      this.$root.$emit("formAmountSubUp");
    },
    minusOne() {
      this.$root.$emit("formAmountOneDown");
    },
    plusOne() {
      this.$root.$emit("formAmountOneUp");
    },
    openSubscriptionModal() {
      this.$root.$emit("setSubscription", true);
      this.$root.$emit("setOneTimePayment", false);
      this.$root.$emit('toggleModalPayment', true);
    },
    openOneTimeModal() {
      this.$root.$emit("setSubscription", false);
      this.$root.$emit("setOneTimePayment", true);
      this.$root.$emit('toggleModalPayment', true);
    },
  },
  name: "Invitation",
  components: { AmountSelect, AmountSelectOneTime },
};
</script>
